export enum DispatchType {
  /**
   * Возврат качественного товара
   */
  RETURN_OF_QUALITY_PRODUCT = 'return_of_quality_product',

  /**
   * Возврат некачественного товара
   */
  RETURN_OF_DEFECTIVE_PRODUCT = 'return_of_defective_product',
}

export enum DispatchReason {
  /**
   * Не подошел по комплекции
   */
  NOT_FIT_BUILD = 'not_fit_build',

  /**
   * Не подошел по конфигурации
   */
  NOT_FIT_CONFIGURATION = 'not_fit_configuration',

  /**
   * Не подошел по цвету
   */
  NOT_FIT_COLOR = 'not_fit_color',

  /**
   * Прочее
   */
  OTHER = 'other',
}

export const DispatchReasonTranslate: Record<string, string> = {
  [DispatchReason.NOT_FIT_BUILD]: 'Не подошел по комплекции',
  [DispatchReason.NOT_FIT_CONFIGURATION]: 'Не подошел по конфигурации',
  [DispatchReason.NOT_FIT_COLOR]: 'Не подошел по цвету',
  [DispatchReason.OTHER]: 'Прочее',
};

export const dispatch_reason = Object.keys(DispatchReasonTranslate).map((f: string) => ({
  text: DispatchReasonTranslate[f],
  value: f,
}));
